//
//import InventoryModel from '@/models/Warehouse/WhInventory'
import StockAdjustTypeModel from '@/models/Warehouse/WhStockAdjustType'
import UserModel from '@/models/General/GUser'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
export default [
    /*{
        name: 'wh_inventory_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'description',
            itemValue: 'id',
            label: 'Inventario',
            model: InventoryModel,
            noObject: true,
            paramSearch: 'description',
        },
    },*/
    {
        name: 'g_user_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noObject: true,
        },
    },
    {
        name: 'wh_warehouse_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noObject: true,
        },
    },
    {
        name: 'wh_stock_adjust_type_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Tipo',
            model: StockAdjustTypeModel,
            noObject: true,
            noAsyncSearch: true,
            paramSearch: 'type',
        },
    }, 
]